document.querySelector(".footer__logo").addEventListener("click", () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});

const productsSlider = new Swiper(".products-slider", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  pagination: {
    el: ".products-slider .swiper-pagination",
    clickable: true,
  },
  spaceBetween: 20,
  breakpoints: {
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    768: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    1024: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
  },
});

const headerMenu = document.querySelector(".header__menu");
const headerBurgerButton = document.querySelector(".header__burger-icon");

headerBurgerButton.addEventListener("click", () => {
  headerMenu.classList.toggle("header__menu--active");
  headerBurgerButton.classList.toggle("header__burger-icon--active");
});

const headerMenuHasChildren = document.querySelectorAll(
  ".header__menu > li.menu-item-has-children > a"
);

if (window.innerWidth < 768) {
  headerMenuHasChildren.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });
}
